import { useParams } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import NewsSection from '../components/NewsSection';

const CategoryPage = () => {
  const { category } = useParams();
  return (
    <>
    <div className="md:mx-20 mx-auto px-4 py-8 min-h-screen">
      <Breadcrumb category={category} />
      <NewsSection category={category} />
    </div>
    </>
  );
};

export default CategoryPage;